export var AdFetchingStatus;
(function (AdFetchingStatus) {
    AdFetchingStatus["OK"] = "OK";
    AdFetchingStatus["EMPTY_VAST"] = "EMPTY_VAST";
    AdFetchingStatus["NO_NABOO_ADS"] = "NO_NABOO_ADS";
    AdFetchingStatus["BAD_INSERTION_METHOD"] = "BAD_INSERTION_METHOD";
})(AdFetchingStatus || (AdFetchingStatus = {}));
